var easingOutQuint = function easingOutQuint(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
};
var smoothScrollPolyfill = function smoothScrollPolyfill(_ref) {
  var node = _ref.node,
    scrollTarget = _ref.scrollTarget,
    duration = _ref.duration;
  var startTime = Date.now();
  var offsetLeft = node.scrollLeft;
  var offsetTop = node.scrollTop;
  var gapHorizontal = scrollTarget.left - offsetLeft;
  var gapVertical = scrollTarget.top - offsetTop;
  var interrupt = false;
  var cleanup = function cleanup() {
    node.removeEventListener('wheel', cancel);
    node.removeEventListener('touchstart', cancel);
  };
  var step = function step() {
    var elapsed = Date.now() - startTime;
    var percentage = elapsed / duration;
    if (interrupt) return;
    if (percentage > 1) {
      node.scrollLeft = scrollTarget.left;
      node.scrollTop = scrollTarget.top;
      cleanup();
      return;
    }
    var nextScrollLeft = easingOutQuint(elapsed, offsetLeft, gapHorizontal, duration);
    var nextScrollTop = easingOutQuint(elapsed, offsetTop, gapVertical, duration);
    node.scrollLeft = Math.abs(scrollTarget.left - nextScrollLeft) <= 1 ? scrollTarget.left : nextScrollLeft;
    node.scrollTop = Math.abs(scrollTarget.top - nextScrollTop) <= 1 ? scrollTarget.top : nextScrollTop;
    requestAnimationFrame(step);
  };
  var cancel = function cancel() {
    interrupt = true;
    cleanup();
  };
  node.addEventListener('wheel', cancel, {
    passive: true
  });
  node.addEventListener('touchstart', cancel, {
    passive: true
  });
  step();
  return cancel;
};
var hasNativeSmoothScroll = function hasNativeSmoothScroll() {
  var supports = false;
  var fakeScrollToOptions = {
    top: 0,
    get behavior() {
      supports = true;
      return 'smooth';
    }
  };
  try {
    var div = document.createElement('div');
    div.scrollTo(fakeScrollToOptions);
  } catch (err) {}
  return supports;
};
export var smoothScroll = function smoothScroll(node, scrollTarget, duration) {
  if (!node) return;
  return smoothScrollPolyfill({
    node: node,
    scrollTarget: scrollTarget,
    duration: duration
  });
};